import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { APIGetUserPreferencesByUserUuid, IUserPreferences } from "../../../api/APIUserPreferences";
import { useAppSelector } from "../../../AppHooks";
import _settings, { getCorrectDomain } from "../../../AppSettings";
import { Notification } from "./Notification";

interface IServerNotificationAPIResponse {
    response: string,
    message: {
        title: string,
        text: string
    }
}

function ServerNotification() {
    const location = useLocation();
    const [show, setShow] = useState(false);
    const [notificationTitle, setNotificationTitle] = useState('');
    const [notificationText, setNotificationText] = useState('');
    const isLoggedIn = useAppSelector(state => state.users.isLoggedIn);

    useEffect(() => {
        // Start drop animation
        const locationToShowAt = [
            '/',
            '/about',
            '/dashboard',
        ];
        const getPreferences = async () => {
            const apiResponse = await APIGetUserPreferencesByUserUuid();
            if (apiResponse === null) {
                return;
            }
            
            const userPrefs: IUserPreferences = apiResponse[0];
            console.log("APIGetUserPreferencesByUserId (Server notification) response: ", userPrefs);
            
            if (locationToShowAt.includes(location.pathname) && userPrefs?.notificationPopupEnabled) {
                setShow(true);
            } else {
                setShow(false);
            }
        }

        if (isLoggedIn) {
            getPreferences();
        }
    }, [location]);

    // Server Sent Events listener
    useEffect(() => {
        // console.log("Connecting to server sent events...");
        
        const eventSource = new EventSource(getCorrectDomain() + _settings.API_SSE_NOTIFICTION_URL);
        eventSource.onmessage = (event) => {
            // console.log("Server sent event: ", event);
            const data:IServerNotificationAPIResponse = JSON.parse(event.data);
            // console.log("Server sent event data: ", data);
            if (data?.message) {
                // console.log("Server sent event message: ", data?.message);
                setNotificationTitle(data?.message.title);
                setNotificationText(data?.message.text);
            }
        }
        eventSource.onerror = (event) => {
            // console.log("Server sent event error: ", event);
            eventSource.close();
        }
        return () => {
            // console.log("Disconnecting from server sent events...");
            
            eventSource.close();
        }
    }, []);

    return (
        <Notification
            show={show && notificationTitle !== "" && notificationText !== ""}
            title={notificationTitle}
            text={notificationText}
            onClose={() => setShow(false)}
        />
    );
}

export default ServerNotification;